import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { singletonHook } from 'react-singleton-hook';
import { DomainConfigContext } from "react-builder";
import { Video, VideoCategory } from "./Videos";


export const useFitness = singletonHook<{ videos: Video[], addVideo: (v: Video) => void, videosBySubCategory: VideoCategory[], loadVideos: (category: string) => Promise<Video[]> }>({} as any, function () {

    const domain = useContext(DomainConfigContext);
    const [videos, setVideos] = useState<Video[]>([]);
    const [videosBySubCategory, setVideosBySubCategory] = useState<VideoCategory[]>([]);
    const [videoPromise, setVideoPromise] = useState<Promise<Video[]> | undefined>();


    const addVideo = function (video: Video) {
        setVideos([...videos, video]);
    }
    const loadVideos = useMemo(() => (category: string): Promise<Video[]> => {

        // in progress
        if (videoPromise) return videoPromise;

        var myHeaders = new Headers();
        myHeaders.append("accept", "application/json, text/plain, */*");

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
        };

        const p = fetch(`${domain?.apiEndpoint}rest/movies/genre/workout/category/${category}`, requestOptions)
            .then(response => response.json())

            .then((result) => {
                setVideos(result as Video[]);
                return result as Video[];
            })
            .catch(error => {
                return [] as Video[];
            }).finally(() => {
                setVideoPromise(undefined);
            });
        setVideoPromise(p)
        return p;
    }, [domain?.apiEndpoint])

    useEffect(() => {

        const map: { [key: string]: Video[] } = videos.reduce((map: any, item) => {
            if (item.subCategory) {
                map[item.subCategory!] = map[item.subCategory!] || [];
                map[item.subCategory!].push(item);
            }
            return map;
        }, {});
        setVideosBySubCategory([...Object.keys(map).map((key, i) => ({ category: key, videos: map[key] }))]);
    }, [videos]);

    return { videos, addVideo, loadVideos, videosBySubCategory };
});